/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ad_Job_Archived_SuccessInputs */

const en_ad_job_archived_success = /** @type {(inputs: Ad_Job_Archived_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AD job archived successfully.`)
};

const fr_ad_job_archived_success = /** @type {(inputs: Ad_Job_Archived_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tâche AD archivée avec succès.`)
};

const de_ad_job_archived_success = /** @type {(inputs: Ad_Job_Archived_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AD-Auftrag erfolgreich archiviert.`)
};

const it_ad_job_archived_success = /** @type {(inputs: Ad_Job_Archived_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Processo AD archiviato correttamente.`)
};

const ru_ad_job_archived_success = /** @type {(inputs: Ad_Job_Archived_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Задание Active Directory успешно завершено.`)
};

const es_ad_job_archived_success = /** @type {(inputs: Ad_Job_Archived_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tarea de AD archivada correctamente.`)
};

const zh_cn2_ad_job_archived_success = /** @type {(inputs: Ad_Job_Archived_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AD作业已成功归档。`)
};

const ja_ad_job_archived_success = /** @type {(inputs: Ad_Job_Archived_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ADジョブは正常にアーカイブされました。`)
};

const hi_ad_job_archived_success = /** @type {(inputs: Ad_Job_Archived_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`विज्ञापन कार्य सफलतापूर्वक संग्रहित हो गया।`)
};

const pt_pt2_ad_job_archived_success = /** @type {(inputs: Ad_Job_Archived_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tarefa do AD arquivada com sucesso.`)
};

/**
* | output |
* | --- |
* | "AD job archived successfully." |
*
* @param {Ad_Job_Archived_SuccessInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const ad_job_archived_success = /** @type {((inputs?: Ad_Job_Archived_SuccessInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ad_Job_Archived_SuccessInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_ad_job_archived_success(inputs)
	if (locale === "de") return de_ad_job_archived_success(inputs)
	if (locale === "it") return it_ad_job_archived_success(inputs)
	if (locale === "ru") return ru_ad_job_archived_success(inputs)
	if (locale === "es") return es_ad_job_archived_success(inputs)
	if (locale === "zh-CN") return zh_cn2_ad_job_archived_success(inputs)
	if (locale === "ja") return ja_ad_job_archived_success(inputs)
	if (locale === "hi") return hi_ad_job_archived_success(inputs)
	if (locale === "pt-PT") return pt_pt2_ad_job_archived_success(inputs)
	return en_ad_job_archived_success(inputs)
});